import React from 'react'
import { AlertTriangle } from 'lucide-react'

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, errorInfo) {
    console.error('[ErrorBoundary]', error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center p-6 bg-background text-foreground">
          <div className="max-w-md w-full rounded-2xl border border-border bg-card p-6 shadow-lg">
            <div className="flex items-center gap-3 text-destructive mb-3">
              <AlertTriangle className="h-8 w-8 shrink-0" aria-hidden />
              <h1 className="text-lg font-semibold">Algo deu errado</h1>
            </div>
            <p className="text-sm text-muted-foreground mb-4">
              Recarregue a página. Se persistir, entre em contato com o suporte.
            </p>
            <button
              type="button"
              className="w-full rounded-lg bg-primary px-4 py-2.5 text-sm font-medium text-primary-foreground touch-manipulation"
              onClick={() => window.location.reload()}
            >
              Recarregar
            </button>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}
